import { FormFieldType } from "models/enums/form";
import { UtilFormTypes } from "models/formTypes";
import { GenericFormField, GenericFormSection } from "models/propTypes/genericFormProps";

function useGetHasValueCount<T extends Record<string, any>>(formValues?: any) {
  const values = formValues ?? {};

  const getHasValueCount = (item: GenericFormField<T> | GenericFormSection<T>, name?: string): number => {
    if (item.innerFields !== undefined && item.type !== FormFieldType.EDITABLETABLE) {
      const innerObj = Array.isArray(item.innerFields)
        ? (item.innerFields as any).map((innerField: GenericFormSection<T>) => getHasValueCount(innerField))
        : Object.entries(item.innerFields ?? {}).map(
            ([key, innerField]) => innerField && getHasValueCount(innerField, key)
          );

      const hasValueCount: number = innerObj.reduce((tot: number, val: number) => tot + val, 0);
      return hasValueCount ?? 0;
    } else {
      const field = item as GenericFormField<T>;
      const fieldValue = name ? values[name] : undefined;

      let hasValueCount = 0;
      if (field.checkHasValue) hasValueCount = field.checkHasValue(fieldValue) ? 1 : 0;
      else if (typeof fieldValue === "boolean") {
        hasValueCount = fieldValue !== undefined ? 1 : 0;
      } else {
        switch (field.type) {
          case FormFieldType.EDITABLETABLE:
            hasValueCount = (fieldValue as any[])?.length ? 1 : 0;
            break;
          case FormFieldType.MONTHRANGE:
          case FormFieldType.DATERANGE:
            const dateRange = fieldValue as UtilFormTypes.DateRange;
            hasValueCount = !!(dateRange?.start || dateRange?.end) ? 1 : 0;
            break;
          case FormFieldType.NUMBERRANGE:
          case FormFieldType.CURRENCYRANGE:
            const range = fieldValue as UtilFormTypes.NumberRange;
            hasValueCount = !!(range?.lowest || range?.highest) ? 1 : 0;
            break;
          case FormFieldType.DIMENSIONSELECTOR:
          case FormFieldType.DIMENSIONINPUTSELECTOR:
            const dimensions = fieldValue as Array<any>;
            hasValueCount = dimensions?.length ?? 0;
            break;
          default:
            hasValueCount = fieldValue !== undefined && fieldValue !== null && fieldValue.length !== 0 ? 1 : 0;
            break;
        }
      }

      return hasValueCount;
    }
  };

  return {
    getHasValueCount,
  };
}

export default useGetHasValueCount;
